exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ftu__container {\n  margin-top: 50px;\n  text-align: center;\n  padding: 0 50px;\n}\n.ftu__container .navigation {\n  line-height: 50px;\n  padding: 20px 0;\n  overflow: hidden;\n  -webkit-touch-callout: none;\n  /* iOS Safari */\n  -webkit-user-select: none;\n  /* Safari */\n  /* Konqueror HTML */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* Internet Explorer/Edge */\n  user-select: none;\n  /* Non-prefixed version, currently\n     supported by Chrome and Opera */\n}\n.ftu__container .previous {\n  float: left;\n  height: 50px;\n}\n.ftu__container .previous--text {\n  display: inline-block;\n  height: 50px;\n  font-weight: bold;\n  font-size: 17px;\n  text-transform: capitalize;\n}\n.ftu__container .next {\n  float: right;\n  height: 50px;\n}\n.ftu__container .next--text {\n  display: inline-block;\n  height: 50px;\n  font-weight: bold;\n  font-size: 17px;\n  text-transform: capitalize;\n}\n.ftu__container .ftu-icon {\n  font-size: 50px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/ftu/ftu.component.scss
// module id = ../../../../../src/app/components/ftu/ftu.component.scss
// module chunks = main